const ISENTO = 'ISENTO'
const LENGTH = 11

function isIsento(value) {
  return !!value && String(value).trim().toUpperCase() === ISENTO
}

function isValid(value) {
  if (value == null || String(value).trim() === '') return true

  return (
    isIsento(value) || new RegExp(`^\\d{${LENGTH}}$`).test(String(value).trim())
  )
}

function sanitize(value) {
  return String(value || '')
    .replace(/\D/g, '')
    .slice(0, LENGTH)
}

export default {
  ISENTO,
  invalidMessage: 'Nº Anvisa deve ter 11 dígitos ou ser ISENTO',
  isIsento,
  isValid,
  sanitize,
}
